export const useDefineSingletonFn = <T = any>(cb: () => T): (() => T) => {
  const state = cb();
  return () => state;
};
